module.exports = __webpack_public_path__ + "static/21-03-25_18-50-59_4754-4d9ee6037270fb0ef1856c16fc513ded.jpg";